<div class="sidebar">
    <app-sidebar-header [title]="INDRA_getTitle() " [label]="''">
        <div actions>
            <button class="button button--small" [disabled]="INDRA_checkMiles()" (click)="!isModificationDisallowed ? INDRA_processAncillary() : INDRA_closeSidebar()" [attr.aria-label]="INDRA_getAriaLabelTranslation('confirmChanges') | ibeadmin: 'sync'" *ngIf="!isServiceLoading && (INDRA_hasAddedAncillaries() || addedAncillary.length != 0)">
				{{ INDRA_getTextTranslation('done') | ibeadmin: 'sync' }}
			</button>
        </div>
    </app-sidebar-header>

    <div class="sidebar__body sl--scrollable" #sidebar__body>
        <app-flight-route [flight]="flightRouteInput"></app-flight-route>
        <!-- LOADING -->
        <app-loading *ngIf="isServiceLoading"></app-loading>

        <ng-container *ngIf="!isServiceLoading">
            <div #sidebar__info>
                <!-- Ancillary Selection Error -->
                <div *ngIf="selectionApiError" class="extras__helper-notification">
                    <app-notification [style]="'alert'" [classes]="'alert-sidebar'" [icon]="'icons.svg#airport--delays'" [title]="INDRA_getOperationErrorNotificationTitle()">
                        <div message>
                            {{'cancelBooking.text.atThisMomentThisOperationCanNotBeDoneSorryByTheInconvenience' | ibeadmin:'sync'}}
                        </div>
                    </app-notification>
                </div>
            </div>
            <div #sidebar__info class="sidebar__info sidebar__info--columns">

                <div class="sidebar__info-text">
                    <ul class="vantages-listing" role="list">
                        <li role="listitem">{{ INDRA_getTextTranslation('upToKg') | ibeadmin: 'sync' }};</li>
                        <li role="listitem">{{ 'ancillaries.type.SPORTS' | ibeadmin | async }} {{ INDRA_getTextTranslation('canBeIncluded') | ibeadmin: 'sync' }};</li>
                        <li role="listitem">{{ INDRA_getTextTranslation('paymentMethod') | ibeadmin: 'sync' }};</li>
                    </ul>
                    <a class="link link--external" (click)="INDRA_gotoURL('externalURLs.aboutSportEquipamentsRules')" href="javascript:;" [attr.aria-label]="(INDRA_getAriaLabelTranslation('openDialogAbout')  | ibeadmin: 'sync')+' '+ (INDRA_getTitle())+' '+ (INDRA_getTextTranslation('rules') | ibeadmin: 'sync')">
						{{ INDRA_getTextTranslation('allAboutSpecialEquipments') | ibeadmin: 'sync' }} {{INDRA_getTitle()}} {{ INDRA_getTextTranslation('rules') | ibeadmin: 'sync' }}
					</a>
                </div>
                <!-- <div class="sidebar__info-image" [style.background-image]="'url(assets/images/ancillaries/brand-extras/sports--small.jpg)'"></div> -->
            </div>

            <div class="flight" *ngFor="let passenger of passengers; let passenger_index = index">
                <div class="passenger">
                    <div class="passenger__details">
                        <h3 class="title-h3 passenger__name">
                            {{INDRA_printPassengerName(passenger)}}
                        </h3>
                    </div>
                    <div class="passenger__actions">
                        <!-- dropdown if many add on is available -->
                        <div class="passenger__actions">
                            <div class="passenger__action" *ngFor="let equipment of INDRA_getAddedAncillariesForPassenger(passenger.idPax); let equipment_index = index">
                                <button class="button button-secondary button--icon-right" [attr.aria-label]="equipment.name + (INDRA_getAriaLabelTranslation('added')  | ibeadmin: 'sync')" (click)="!isModificationDisallowed ? INDRA_removeAncillary(equipment) : return;">
									{{(translationAncillaryDetailedKey + equipment.code) | ibeadmin:'sync'}} 
									{{ INDRA_getTextTranslation('added') | ibeadmin: 'sync' }}
									<app-svg svg="icons.svg#general--check" aria-hidden="true" [alt]="'Added icon'"></app-svg>
									<span class="extra-price" [attr.aria-label]="equipment.price">
										({{ equipment.price + INDRA_getCurrencySymbol(equipment.currency) | indracurrency }})
									</span>
								</button>
                                <app-svg [ngClass]="['remove-extra']" [attr.aria-label]="(INDRA_getAriaLabelTranslation('remove')  | ibeadmin: 'sync') + equipment.name" (click)="INDRA_removeAncillary(equipment)" svg="icons.svg#general--close" [alt]="'Remove icon'" *ngIf="!isModificationDisallowed">
                                </app-svg>
                            </div>
                            <form [formGroup]="form" *ngIf="!isModificationDisallowed && this.formsPerPassenger[passenger_index] as form" class="passenger__action">
                                <div *ngIf="INDRA_getAddOnForPassenger(passenger.idPax).length > 0">
                                    <app-select-input-indra selectId="{{'selectEquipment'+passenger_index}}" placeholder="{{INDRA_getTextTranslation('addEquipment') | ibeadmin: 'sync' }}" formControlName="equipmentAdd" [options]="INDRA_getOptionList(passenger_index)" selectLabel="{{'bookingDetails.alt.selectEquipment' | ibeadmin: 'sync'}}">
                                    </app-select-input-indra>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="passenger__callouts" *ngIf="!isModificationDisallowed && this.formsPerPassenger[passenger_index] as form">
                    <div *ngIf="INDRA_chosenValue(passenger_index)">
                        <form [formGroup]="this.formsPerPassenger[passenger_index]" role="alert" [attr.aria-label]="INDRA_getAriaLabelTranslation('formToConfirmTheInformationToContinue')  | ibeadmin: 'sync'">
                            <h4 class="title-h4">{{ INDRA_getTextTranslation('confirmToContinue') | ibeadmin: 'sync' }}</h4>
                            <app-checkbox-input formControlName="weightCheck" [parentForm]="form" label="{{ INDRA_getTextTranslation('confirmWeight') | ibeadmin: 'sync' }} {{ INDRA_getWeightLimit(this.formsPerPassenger[passenger_index].value)}}">
                            </app-checkbox-input>
                            <app-checkbox-input formControlName="dimensionCheck" [parentForm]="form" label="{{ INDRA_getTextTranslation('confirmDimension') | ibeadmin: 'sync' }} {{ INDRA_getDimensionLimit(this.formsPerPassenger[passenger_index].value) }}">
                            </app-checkbox-input>
                        </form>
                        <app-notification [style]="'note'" [classes]="'alert-sidebar'" [title]="''" *ngIf="!INDRA_hasCheckedRequirements(passenger_index)">
                            <div message>
                                {{ INDRA_getTextTranslation('weightHigher') | ibeadmin: 'sync' }} {{ INDRA_getWeightLimit(this.formsPerPassenger[passenger_index].value)}} {{ INDRA_getTextTranslation('contactCallCenter') | ibeadmin: 'sync' }}
                                <h2 class="bold">{{'addMoreSidebars.general.texts.callCenterNumber' | ibeadmin:'sync'}}</h2>
                            </div>
                        </app-notification>
                    </div>
                    <div class="passenger__action" *ngIf="INDRA_hasCheckedRequirements(passenger_index)" role="alert">
                        <button class="button" [attr.aria-label]="INDRA_chosenValue(passenger_index)" (click)="INDRA_handleAddAncillary(this.INDRA_chosenValueFromCollection(passenger_index));INDRA_resetPassengerForm(passenger_index)">
							{{ INDRA_getTextTranslation('add') | ibeadmin: 'sync' }}
							{{(translationAncillaryDetailedKey + INDRA_chosenValue(passenger_index).code) | ibeadmin:'sync'}}
						</button>
                    </div>
                </div>
            </div>

            <div class="extras__helper with-notification" *ngIf="!isModificationDisallowed && ((INDRA_checkOtherFlightAncillaries() && INDRA_hasAddedAncillaries()) || notificationShowing)">
                <!-- IBETPIDOS-8850 : Removed "Apply the same to other flights" link
                <div class="extras__helper-actionable">
                    <a class="link" (click)="INDRA_handleApplyAll()" title="Apply your chosen extras to all the remaining flights">{{
						INDRA_getTextTranslation('applyToOtherFlights') | ibeadmin: 'sync' }}</a>
                </div> -->
                <div #sidebar__notification class="extras__helper-notification" role="status" tabindex="0" [class.is-showing]="notificationShowing" [attr.aria-hidden]="!notificationShowing">
                    {{ notificationMessage }}
                </div>
            </div>

            <div class="sidebar__payment_totals">
                <div class="total" *ngIf="INDRA_hasAddedAncillaries()">
                    <label class="label">
						{{ INDRA_printItemsCount() }} {{INDRA_getTextTranslation('items')  | ibeadmin: 'sync'}}
					</label>
                    <p class="value">{{ INDRA_printTotal() | indracurrency }}</p>
                </div>

                <app-extras-sidebar-miles-info [milesNeeded]="milesNeeded" [addedAncillary]="addedAncillary" [payExtrasWithMiles]="payWithMiles" [notEnoughMilesFlag]="notEnoughMilesFlag" [hasAddedExtrasFlag]="hasAddedExtrasFlag" (isChecked)="INDRA_payAncillaryWithMiles($event)"
                    *ngIf="!isModificationDisallowed">
                </app-extras-sidebar-miles-info>

                <div class="flow_actions" *ngIf="INDRA_hasAddedAncillaries()">
                    <!-- IBETPIDOS-8890: Remove "Select for next flight button" -->
                    <!-- <app-flights-navigation [ancillaryType]="ancillariesType"></app-flights-navigation> -->
                </div>

                <div class="flow_actions" [ngClass]="INDRA_flowActionsClasses()" *ngIf="!isModificationDisallowed && (INDRA_hasAddedAncillaries() || addedAncillary.length != 0)">
                    <!--
					<button 
						class="button" 
						(click)="INDRA_handleNext()" 
						[attr.aria-label]="(INDRA_getAriaLabelTranslation('selectNextFlight')  | ibeadmin: 'sync')"
						*ngIf="INDRA_hasNextFlight()">{{INDRA_getTextTranslation('selectNextFlight')  | ibeadmin: 'sync'}}
					</button>
					-->
                    <button class="button" [disabled]="INDRA_checkMiles()" (click)="INDRA_processAncillary()" [attr.aria-label]="(INDRA_getAriaLabelTranslation('selectNextFlight')  | ibeadmin: 'sync')+' '+ (INDRA_getTitle())+' '+(INDRA_getAriaLabelTranslation('closeDialog')  | ibeadmin: 'sync')">
						{{ INDRA_getTextTranslation('done') | ibeadmin: 'sync' }}
					</button>
                </div>
            </div>
            <div class="conditions">
                <h3 class="title-h3 conditions__title">{{ INDRA_getTitleTranslation('conditions') | ibeadmin: 'sync' }}</h3>
                <div class="conditions__text">
                    <div class="grid">
                        <div class="col-12 col-tp-12 col-p-12">
                            <ul class="bullet-list" role="list">
                                <li role="listitem">{{ INDRA_getTextTranslation('notTransferable') | ibeadmin: 'sync' }}</li>
                                <li role="listitem">{{ INDRA_getTextTranslation('notChangeable') | ibeadmin: 'sync' }}</li>
                                <li role="listitem">{{ INDRA_getTextTranslation('availableForFlight') | ibeadmin: 'sync' }}</li>
                                <li role="listitem">{{ INDRA_getTextTranslation('availableForHours') | ibeadmin: 'sync' }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <a class="link link--external" href="javascript:;" (click)="INDRA_gotoURL('externalURLs.aboutSportEquipamentsRules')">
					{{ INDRA_getTextTranslation('allTermsAndConditions') | ibeadmin:'sync' }}
				</a>
            </div>
        </ng-container>
    </div>
    <div #sidebar__footer class="sidebar__footer ">

    </div>
</div>